/* eslint-disable no-undef */
import _ from 'lodash';
import angular from 'angular';

export const PROFILE_FOR_SUBMISSION_TYPE = 'p4s';
export const WORKFLOW_CREATION_DATE_LAST_DIGITS_LENGTH = 4;

export function PublicProfileLinkGenerator($state) {
    const generateLink = (candidate, { isProfileForSubmission, isNamedProfile }) => {
        const talentId = _.get(candidate, 'candidateData.talentId');
        const workflowId = _.get(candidate, 'workflow._id');
        const isAutoFeedbackCandidate = _.get(candidate, 'workflow.feedback.type') === 'automatic';

        if (isAutoFeedbackCandidate) {
            return '';
        }

        if (!talentId) {
            throw new Error('Link for public profile can\'t be generated as talentId is not defined');
        }

        if (!workflowId) {
            throw new Error('Link for public profile can\'t be generated as workflowId is not defined');
        }

        const workflow  = _.get(candidate, 'workflow');
        const workflowDateOptionalParam = isNamedProfile ? getWorkflowDate(workflow) : '';
        const profileForSubmissionOptionalParam = isProfileForSubmission ? PROFILE_FOR_SUBMISSION_TYPE : '';
        const link = $state.href('publicProfile', {
            talentId,
            workflowId,
            workflowDate: workflowDateOptionalParam,
            profileForSubmissionParam: profileForSubmissionOptionalParam,
        });

        return `${location.href.replace(location.hash, '')}${link}`;
    };

    const getWorkflowDate = (workflow) => {
        let workflowDate = _.get(workflow, 'created');
        const workflowDateLength = workflowDate.length;

        if (workflowDateLength >= WORKFLOW_CREATION_DATE_LAST_DIGITS_LENGTH) {
            const beginIndex = workflowDate.length - WORKFLOW_CREATION_DATE_LAST_DIGITS_LENGTH;

            return workflowDate.slice(beginIndex, workflowDateLength);
        }
    };

    const isParamProfileForSubmissionType = (profileForSubmissionParam) => {
        return profileForSubmissionParam === PROFILE_FOR_SUBMISSION_TYPE;
    };

    return {
        generateLink,
        getWorkflowDate,
        isParamProfileForSubmissionType,
    }
}

angular.module('TALENYA-FE').factory('PublicProfileLinkGenerator', PublicProfileLinkGenerator);
